import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navigation } from './navigation/react-redux-nav';

import Intro from './pages/intro';
import IntroWolf from './pages/intro-wolf';
import Checkout from './pages/checkout';
import ConnectSelection from './pages/connect-selection';
import OtherProductSelection from './pages/other-product-selection';
import IfitSmartAppLink from './pages/unsupported-products/ifit-smart-app-link';
import FusionCSTAppLink from './pages/unsupported-products/fusion-cst-app-link';
import SleepAppLink from './pages/unsupported-products/sleep-app-link';
import AltraIQAppLink from './pages/unsupported-products/altra-iq-app-link';
import WearableSelection from './pages/wearable-selection';
import CreateAccountLoginInfo from './pages/create-account-login-info';
import PlanSelection from './pages/plan-selection';
import LoginWithEmail from './pages/login-email';
import Birthday from './pages/profile-settings/birthday';
import Gender from './pages/profile-settings/gender';
import CurrentHeight from './pages/profile-settings/current-height';
import { CurrentWeightPage, GoalWeightPage } from './pages/profile-settings/weight-selection';
import DailyActivity from './pages/profile-settings/daily-activity';
import FitnessGoalPage from './pages/fitness-plan-settings/fitness-goal';
import FitnessIntro from './pages/fitness-plan-settings/fitness-intro';
import WorkoutType from './pages/fitness-plan-settings/workout-type';
import PerformanceAreas from './pages/fitness-plan-settings/performance-areas';
import WorkoutIntensityPage from './pages/fitness-plan-settings/workout-intensity';
import PreferredWorkoutDays from './pages/fitness-plan-settings/preferred-workout-days';
import ConfirmYourFormula from './pages/fitness-plan-settings/confirm-your-formula';
import EquipmentPreferences from './pages/fitness-plan-settings/equipment-preferences';
import PreferredWorkoutLength from './pages/fitness-plan-settings/preferred-workout-length';
import MultiFitnessGoal from './pages/fitness-plan-settings/multi-fitness-goal';
import MuscleGroupsPage from './pages/fitness-plan-settings/muscle-groups';
import WeeklyWeightGoal from './pages/profile-settings/weekly-weight-goal';
import WeeklyWeightLossGoal from './pages/profile-settings/weight-loss-goal';
import ForgotPassword from './pages/forgot-password';
import ShippingAddress from './pages/shipping-address';
import OptionalShipping from './pages/shipping-address/optional-shipping';
import ActivationCode from './pages/activation';
import ActivateEmail from './pages/activate-email';
import ManualActivation from './pages/manual-activation';
import ActivationStep1 from './pages/manual-activation/step-1';
import ActivationStep2 from './pages/manual-activation/step-2';
import ActivationStep3 from './pages/manual-activation/step-3';
import PersonalizeStart from './pages/personalize-start';
import PersonalizeSummary from './pages/personalize-summary';

import './sass/fonts.css';
import './app.css';

export default class App extends Component {
  static propTypes = {
    pages: PropTypes.objectOf(PropTypes.string),
    planetFitnessSSOCode: PropTypes.string
  };

  getComponentFromPage = (page) => {
    const { pages, planetFitnessSSOCode } = this.props;

    return {
      [pages.INTRO]: <Intro />,
      [pages.INTRO_WOLF]: <IntroWolf />,
      [pages.CHECKOUT]: <Checkout />,
      [pages.CONNECT_SELECTION]: <ConnectSelection />,
      [pages.OTHER_PRODUCT_SELECTION]: <OtherProductSelection />,
      [pages.CARDIO_APP_LINK]: <IfitSmartAppLink />,
      [pages.FUSION_APP_LINK]: <FusionCSTAppLink />,
      [pages.SLEEP_APP_LINK]: <SleepAppLink />,
      [pages.ALTRA_IQ_APP_LINK]: <AltraIQAppLink />,
      [pages.WEARABLE_SELECTION]: <WearableSelection />,
      [pages.CREATE_ACCOUNT_LOGIN_INFO]: <CreateAccountLoginInfo />,
      [pages.LOGIN_WITH_EMAIL]: <LoginWithEmail planetFitnessSSOCode={ planetFitnessSSOCode } />,
      [pages.FORGOT_PASSWORD]: <ForgotPassword />,
      [pages.SHIPPING_ADDRESS]: <ShippingAddress />,
      [pages.OPTIONAL_SHIPPING_ADDRESS]: <OptionalShipping />,
      [pages.ACTIVATION_CODE]: <ActivationCode />,
      [pages.ACTIVATE_EMAIL]: <ActivateEmail />,
      [pages.GENDER]: <Gender />,
      [pages.CURRENT_HEIGHT]: <CurrentHeight />,
      [pages.CURRENT_WEIGHT]: <CurrentWeightPage />,
      [pages.GOAL_WEIGHT]: <GoalWeightPage />,
      [pages.DAILY_ACTIVITY]: <DailyActivity />,
      [pages.WEEKLY_WEIGHT_GOAL]: <WeeklyWeightGoal />,
      [pages.WEEKLY_WEIGHT_LOSS_GOAL]: <WeeklyWeightLossGoal />,
      [pages.PERSONALIZE_SUMMARY]: <PersonalizeSummary />,

      [pages.PLAN_SELECTION]: <PlanSelection />,
      [pages.FITNESS_INTRO]: <FitnessIntro />,
      [pages.WORKOUT_INTENSITY]: <WorkoutIntensityPage />,
      [pages.FITNESS_GOAL]: <FitnessGoalPage />,
      [pages.PREFERRED_WORKOUT_DAYS]: <PreferredWorkoutDays />,
      [pages.PREFERRED_WORKOUT_LENGTH]: <PreferredWorkoutLength />,
      [pages.EQUIPMENT_PREFERENCES]: <EquipmentPreferences />,
      [pages.CONFIRM_YOUR_FORMULA]: <ConfirmYourFormula />,

      [pages.ACTIVATION_STEPS]: (
        <ManualActivation>
          <ActivationStep1 />
          <ActivationStep2 />
          <ActivationStep3 />
        </ManualActivation>
      ),
      [pages.BIRTHDAY]: <Birthday />,
      [pages.WORKOUT_TYPE]: <WorkoutType />,
      [pages.MULTI_FITNESS_GOAL]: <MultiFitnessGoal />,
      [pages.MUSCLE_GROUPS]: <MuscleGroupsPage />,
      [pages.PERFORMANCE_AREAS]: <PerformanceAreas />,
      [pages.PERSONALIZE_START]: <PersonalizeStart />,
      [pages.USER_PROFILE_LANDING]: <Birthday />
    }[page] || (
      <div>
        <Navigation.Backward><button>Back</button></Navigation.Backward>
        <p>Unimplemented Page: {page}</p>
      </div>
    );
  }

  render() {
    return <Navigation.Provider render={ this.getComponentFromPage } />;
  }
}
